import React, { PureComponent } from 'react';
import ReactDOMServer from 'react-dom/server';
import _ from 'lodash';
import { Form, Input, Button, Upload, Icon, Alert, notification } from 'antd';
import { withRedux } from '../../hoc';
import { createMediasApi } from '../../services/medias';
import { createCareersApi } from '../../services/careers';
import { sendMail } from '../../services/mail';
import { json2table, getServiceUrl } from '../../utils';

const FormItem = Form.Item;

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages')
  };
};

const actions = {};

@Form.create()
@withRedux(mapStateToProps, actions)
export default class JoinUsForm extends PureComponent {
  state = {
    uploading: false,
    errorMessage: null
  };
  submit = async values => {
    const { t } = this.props;
    if (this.state.uploading) return false;
    this.setState({ uploading: true, errorMessage: null });
    const uploadResult = await createMediasApi(values.resume.file);
    if (_.get(uploadResult, 'status') === 'error') {
      this.setState({ errorMessage: _.get(uploadResult, 'message'), uploading: false });
      return false;
    }
    const media = _.get(uploadResult, 'data');
    const full_file_path = `${getServiceUrl()}/${_.get(media, 'path')}`;
    const mediaId = _.get(media, 'id');
    const createResult = await createCareersApi({
      name: _.get(values, 'name'),
      email: _.get(values, 'email'),
      telephone: _.get(values, 'telephone'),
      media_resume_id: mediaId
    });
    if (_.get(createResult, 'status') === 'error') {
      this.setState({ errorMessage: _.get(createResult, 'message'), uploading: false });
      return false;
    }
    const sendMailResult = await sendMail({
      subject: `${t('คุณมีการติดต่อจาก')} ${_.get(values, 'email')}`,
      html: ReactDOMServer.renderToString(
        <div>
          {json2table({
            data: {
              Name: _.get(values, 'name'),
              'E-mail': _.get(values, 'email'),
              Telephone: _.get(values, 'telephone'),
              Resume: full_file_path
            }
          })}
        </div>
      )
    });
    console.log('sendMailResult', sendMailResult);
    notification.success({
      message: t('Send Success')
    });
    this.setState({ uploading: false });
    this.props.form.resetFields();
    return true;
  };
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.submit(values);
      }
    });
  };
  getAcceptFile = () => {
    return 'image/*, video/*, application/pdf, .pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv, .doc, .docx, application/msword';
  };
  render() {
    const { t } = this.props;
    const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
    const { uploading, errorMessage } = this.state;
    const uploadProps = {
      accept: this.getAcceptFile(),
      onRemove: () => {
        setFieldsValue({ resume: [] });
      },
      beforeUpload: file => {
        return false;
      },
      fileList: _.get(getFieldValue('resume'), 'fileList.0') ? [_.get(getFieldValue('resume'), 'fileList.0')] : []
    };
    return (
      <React.Fragment>
        {errorMessage && <Alert message={errorMessage} type="warning" showIcon closable />}
        <Form onSubmit={this.handleSubmit} className="join-us-form">
          <FormItem colon={false} label={t('Name')}>
            {getFieldDecorator('name', {
              rules: [
                {
                  required: true,
                  message: t('Please input your Name!')
                }
              ]
            })(<Input />)}
          </FormItem>
          <FormItem colon={false} label={t('E-mail')}>
            {getFieldDecorator('email', {
              rules: [
                {
                  type: 'email',
                  message: t('The input is not valid E-mail!')
                },
                {
                  required: true,
                  message: t('Please input your E-mail!')
                }
              ]
            })(<Input />)}
          </FormItem>
          <FormItem colon={false} label={t('Telephone')}>
            {getFieldDecorator('telephone', {
              rules: [
                {
                  required: true,
                  message: t('Please input your Telephone!')
                }
              ]
            })(<Input />)}
          </FormItem>
          <FormItem colon={false} label={t('Resume')}>
            {getFieldDecorator('resume', {
              rules: [{ required: true, message: t('Please Upload Resume!') }]
            })(
              <Upload {...uploadProps}>
                <Button type="danger" className="no-shadow">
                  {t('Choose file')} <Icon type="upload" />
                </Button>
              </Upload>
            )}
          </FormItem>
          <FormItem colon={false} style={{ textAlign: 'right' }}>
            <Button type="primary" htmlType="submit" className="join-us-form-button" loading={uploading}>
              {t('Apply')}
            </Button>
          </FormItem>
        </Form>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/JoinUsForm.js